import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaFileInvoiceDollar } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import '../../../assets/css/ClientSidebar.css';

import Adminprofil from '../../../assets/images/adminprofil.png';
import { Tooltip } from 'react-tooltip'

import api from '../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';

const PaymentList = () => {

    const [UserData, setUserData] = useState([]);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [patients, setPatients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalPatients, setTotalPatients] = useState(0);
    const [loading, setLoading] = useState(false);
    const limit = 10; // Nombre de patients par page
    const [departments, setDepartments] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filteredBillings, setFilteredBillings] = useState([]);
    const [billings, setBillings] = useState([]);
    const [showModal, setShowModal] = useState(false); // Gère l'ouverture/fermeture du modal
    const [selectedBilling, setSelectedBilling] = useState({
        paymentuniqueId: '',
        operationtype: '',
        operationcode: '',
        department: '',
        amount: 0,
        currency: '',
        paymentstatus: false, // Par défaut "Pending"
    });

    const handleShowModal = (billing) => {
        setSelectedBilling(billing); // Mettre à jour les détails du billing
        setShowModal(true); // Afficher le modal
    };

    const handleCloseModal = () => {
        setShowModal(false); // Fermer le modal
        setSelectedBilling({
            paymentuniqueId: '',
            operationtype: '',
            operationcode: '',
            department: '',
            amount: 0,
            currency: '',
            paymentstatus: false,
        }); // Réinitialiser uniquement les propriétés, mais ne pas rendre null
    };

    // GEt patients list
    const fetchPatients = async (page = 1) => {
        setLoading(true);
        try {
            const response = await api.get(`/clinic/patients?page=${page}&limit=${limit}`);
            setPatients(response.data.patients);
            setTotalPages(response.data.totalPages);
            setTotalPatients(response.data.totalPatients);
            setCurrentPage(response.data.currentPage);
        } catch (error) {
            console.error('Erreur lors de la récupération des patients:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');

                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);


    // liste des billings
    useEffect(() => {
        if (!UserData || !UserData.hospital_id || !UserData.role) return;

        const fetchBillings = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const response = await api.get('/clinic/allbilling');
                let billingsData = response.data;
                console.log('Billings Data:', billingsData);

                // Vérifier si UserData.hospital_id est un tableau ou un objet
                let hospitalIds = [];
                if (Array.isArray(UserData.hospital_id)) {
                    hospitalIds = UserData.hospital_id.map(hospital => hospital._id);
                } else {
                    hospitalIds = [UserData.hospital_id._id];
                }

                // Filtrer par hôpital
                billingsData = billingsData.filter(billing =>
                    hospitalIds.includes(billing.hospitalId)
                );

                // Filtrage par rôle
                if (UserData.role.name === 'medtinz_client_patient') {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const patientId = patientResponse.data._id;
                    const filteredBillingsforpatient = billingsData.filter(billingData =>
                        billingData.patientId._id === patientId
                    );

                    setBillings(filteredBillingsforpatient);
                    setFilteredBillings(filteredBillingsforpatient);
                } else {
                    setBillings(billingsData);
                    setFilteredBillings(billingsData);
                }
            } catch (error) {
                console.error('Error fetching billings:', error);
                alert('Failed to fetch billings');
            }
        };

        fetchBillings();
    }, [UserData]);




    // useEffect(() => {
    //     const fetchBillings = async () => {
    //         try {
    //             const response = await api.get('/clinic/allbilling');
    //             setBillings(response.data); // Mettre à jour les données des rendez-vous
    //             setFilteredBillings(response.data); // Initial filter with all data
    //         } catch (error) {
    //             console.error('Error fetching billings:', error);
    //             alert('Failed to fetch billings');
    //         }
    //     };

    //     fetchBillings();
    // }, []);


    // listes des departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });

                // Mettre à jour les départements dans l'état
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des départements:', error);
            }
        };
        fetchDepartments(); // Appel de la fonction pour récupérer les départements
    }, []);


    // search
    const handleSearchChange = async (e) => {
        const value = e.target.value; // Récupérer la valeur entrée par l'utilisateur
        setSearchTerm(value);

        if (!value) {
            // Si le champ est vide, rechargez la liste complète
            fetchPatients(currentPage);
            return;
        }

        setLoading(true);
        try {
            const response = await api.get(`/clinic/patients/searchpatient`, {
                params: {
                    query: value, // Envoyer la valeur unique au backend
                },
            });
            setPatients(response.data); // Mettre à jour la liste des patients
        } catch (error) {
            console.error('Erreur lors de la recherche des patients:', error);
            setPatients([]); // Si une erreur se produit, afficher une liste vide
        } finally {
            setLoading(false);
        }
    };

    const handleinvoicepayment = async (billingID) => {

        navigate(`/Billings/invoiceAssurance/${billingID}`, {
            state: { billingID },  // Passer les signes vitaux existants dans l'état de navigation
        });
    };

    const handleDateFilterChange = () => {
        // Créer des objets Date à partir des dates startDate et endDate
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Normaliser les dates pour ignorer l'heure
        start.setHours(0, 0, 0, 0); // Mettre l'heure à minuit
        end.setHours(23, 59, 59, 999); // Mettre l'heure à 23:59:59.999 pour inclure toute la journée

        // Filtrer les billings en fonction des dates
        const filtered = billings.filter((billing) => {
            const billingDate = new Date(billing.createdAt); // Date du billing
            billingDate.setHours(0, 0, 0, 0); // Normaliser la date de billing

            // Comparer la date de billing avec la plage de dates
            return billingDate >= start && billingDate <= end;
        });

        setFilteredBillings(filtered); // Mettre à jour les billings filtrés
    };


    const resetFilter = () => {
        setStartDate('');
        setEndDate('');
        setFilteredBillings(billings); // Reset to all billings
    };



    return (
        <div className="dashboard-header" >
            <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
                <CContainer fluid className="d-flex align-items-center">
                    <div className='row w-100'>
                        {/* Barre de recherche */}
                        <div className="pagetittle col">
                            <h4><b>Billing Management</b></h4>
                            <p>Home <BsChevronRight className='mx-2' style={{ fontSize: "12px" }} />  Dashboard <BsChevronRight style={{ fontSize: "12px" }} className='mx-2' />  <span style={{ color: '#191B1C' }}>Billing Management</span></p>
                        </div>
                        {/* Profil utilisateur */}

                        <div className=' d-flex col justify-content-end'>
                            <CHeaderNav>
                                <CNavItem>
                                    <CNavLink href="#" className="d-flex ms-auto">
                                        <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                                        <div>
                                            <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                                            <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                                        </div>
                                    </CNavLink>
                                </CNavItem>
                            </CHeaderNav>
                        </div>
                    </div>
                </CContainer>
            </CHeader>

            <div className="Patientlist mt-2"  >
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <div className='tablist ' >
                                        <div className='patientlistline'>
                                            <div className="search-container w-100">
                                                <div className="search-container w-80">
                                                    <div className="search-bar">
                                                        <FaSearch size="sm" className="search-icon " style={{ width: '20px', height: '20px' }} />
                                                        <input
                                                            className='ms-4'
                                                            type="text"
                                                            placeholder="Search for a patient (Enter ID, name or Tel)"
                                                            value={searchTerm}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=''>
                                            <div className="filter-bar" style={{ width: '100%' }}>
                                                <button className="filter-button">
                                                    <input
                                                        type="date"
                                                        value={startDate}
                                                        onChange={(e) => setStartDate(e.target.value)}
                                                        className="date-filter-input"
                                                    />
                                                    <input
                                                        type="date"
                                                        value={endDate}
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                        className="date-filter-input"
                                                    />
                                                </button>
                                                <button className="filter-button" onClick={handleDateFilterChange}>
                                                    Filter By Date<FaFilter className="icon" />
                                                </button>

                                                <button className="reset-button" onClick={resetFilter}>
                                                    <FaRedoAlt className="icon" /> Reset Filter
                                                </button>
                                            </div>
                                        </div>

                                        <div className='patientlisttable'>
                                            <CTable className="mt-5 ctable-no-border " align="middle" responsive>
                                                <CTableHead>
                                                    <CTableRow className='tablehead'>
                                                        <CTableHeaderCell scope="col">Payment ID</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Service type</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Service Code</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Patient</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Department</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Amount</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                                                    </CTableRow>
                                                </CTableHead>
                                                <CTableBody>
                                                    {filteredBillings.map((billing) => (
                                                        <CTableRow className="ctable-row" key={billing._id}>
                                                            <CTableDataCell>{billing.paymentuniqueId || 'N/A'}</CTableDataCell>
                                                            <CTableDataCell>{billing.operationtype || 'N/A'}</CTableDataCell>
                                                            <CTableDataCell>{billing.operationcode || 'N/A'}</CTableDataCell>
                                                            <CTableDataCell>{billing.patientId ? `${billing.patientId.firstname} ${billing.patientId.lastname}` : 'N/A'}</CTableDataCell>
                                                            <CTableDataCell> {
                                                                departments.find(department => department._id === billing.department)?.name || 'N/A'
                                                            }</CTableDataCell>
                                                            <CTableDataCell>{billing.amount || 'N/A'} {billing.currency || 'N/A'}</CTableDataCell>
                                                            <CTableDataCell> <span className={billing.paymentstatus ? 'coloredsucess' : 'coloredwarning'}>
                                                                {billing.paymentstatus ? 'Paid' : 'Pending'}
                                                            </span></CTableDataCell>
                                                            <CTableDataCell>
                                                                <button
                                                                    className="btn btn-primary"
                                                                    style={{ borderRadius: '30px', padding: '5px 30px' }}
                                                                    onClick={() => handleShowModal(billing)}
                                                                >
                                                                    View Details
                                                                </button>
                                                            </CTableDataCell>

                                                        </CTableRow>
                                                    ))}
                                                </CTableBody>
                                            </CTable>
                                        </div>
                                    </div>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>

            {/* Modal pour afficher les détails du billing */}
            <CModal visible={showModal} onClose={handleCloseModal} size='lg'>
                <CModalHeader>
                    <CModalTitle>Billing Details</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    {selectedBilling ? (
                        <div>
                            <p><strong>Payment ID:</strong> {selectedBilling.paymentuniqueId}</p>
                            <p><strong>Service Type:</strong> {selectedBilling.operationtype}</p>
                            <p><strong>Service Code:</strong> {selectedBilling.operationcode}</p>
                            <p><strong>Department:</strong> {departments.find(department => department._id === selectedBilling.department)?.name}</p>
                            <p><strong>Amount:</strong> {selectedBilling.amount} {selectedBilling.currency}</p>
                        </div>
                    ) : (
                        <p>Loading...</p>
                    )}
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={handleCloseModal}>Close</CButton>
                    <button
                        className="btn btn-primary"
                        style={{ borderRadius: '30px', padding: '10px 20px' }}
                        onClick={() => handleinvoicepayment(selectedBilling._id)} // Utiliser selectedBilling au lieu de billing
                        disabled={selectedBilling.paymentstatus}>
                        <FaFileInvoiceDollar /> Make Payment
                    </button>
                </CModalFooter>
            </CModal>
        </div >
    );
}

export default PaymentList;
